'use client';
import HeaderVariety from '@primitives/HeaderVariety';
import NavCard from './_NavCard';

const NavCards = ({ _meta, navCards, title, headerVariation, _testID }) => {
  const footerCards = _meta?.schema?.indexOf('footer') >= 0;
  return (
    <div
      className={`py-16 ${footerCards ? '' : 'rotating-background'} ${
        footerCards
          ? 'bg-gradient-to-b from-white from-25% via-white via-75% to-neutral-900 to-75%'
          : ''
      }`}
      data-test-id={`nav_cards_${_testID}`}
    >
      <div className="container mx-auto">
        {title && (
          <div className="mb-6 text-center md:mb-8">
            <HeaderVariety defaultVariation="h2" headerVariation={headerVariation?.headerVariation}>
              {title}
            </HeaderVariety>
          </div>
        )}
        <ul className="flex flex-col list-none md:flex-row">
          {navCards.map((card, i) => (
            <NavCard key={i} {...card} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default NavCards;
